import { z } from "zod";

// Mother-level postnatal consultation fields. The per-baby (Subject + Objective)
// fields moved to baby observations (KIN-1075) and are validated separately by
// validateBabyObservations.
export const formSchema = z.object({
  issues: z.string().min(1, { message: "Enter the information about Issues." }),
  postNatalMood: z
    .string()
    .min(1, { message: "Enter the information about Post Natal Mood." }),
  supports: z
    .string()
    .min(1, { message: "Enter the information about Supports." }),
  mirena: z.string().min(1, { message: "Enter the information about Mirena." }),
  contraception: z
    .string()
    .min(1, { message: "Enter the information about Contraception." }),
  gravida: z.string().min(1, { message: "Enter the number of pregnancies." }),
  para: z.string().min(1, { message: "Enter the number of births." }),
});
